import React, { useEffect, useState } from 'react';
import {getDonneInstantanee} from "../ConnectionBDD";


const unitLinks = {
    "°C": "Degr%C3%A9_Celsius",
    "hPa": "Hectopascal",
    "W/m²": "Watt_par_m%C3%A8tre_carr%C3%A9",
    "UV": "Indice_UV",
    "Km/h": "Kilom%C3%A8tre_par_heure",
    " ": "Rose_des_vents",
    "%": "Humidit%C3%A9",
    "Cb": "Tensiomètre_(science_des_sols)#:~:text=Un%20tensiomètre%20en%20science%20du,irrigation%20aux%20besoins%20des%20cultures.",

};

const WeatherInfoCard = ({ title, value, unit, className }) => {
    const handleUnitClick = () => {
        // Rediriger l'utilisateur vers la page Wikipedia de l'unité correspondante
        const unitLink = unitLinks[unit];
        if (unitLink) {
            window.open(`https://fr.wikipedia.org/wiki/${unitLink}`, '_blank');
        }
    };

    return (
        <div className={`weather-info-card ${className}`} onClick={handleUnitClick}>
            <div className="weather-info-title">
                <strong>{title} :</strong>
            </div>
            <div className="weather-info-value"  style={{ cursor: 'pointer' }}>
                {value} {unit}
            </div>
        </div>
    );
};

function directionVent(degrees) {
    if (degrees < 0 || degrees > 360) {
        return "Degré invalide, doit être entre 0 et 360";
    }

    const directions = [
        "N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE",
        "S", "SSO", "SO", "OSO", "O", "ONO", "NO", "NNO", "N"
    ];

    // Chaque segment est de 22.5 degrés (360° / 16 directions)
    const index = Math.round(degrees / 22.5) % 16;
    return directions[index];
}

const DonneeInstantanee = () => {
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getDonneInstantanee();
                setData(response[0]);
            } catch (error) {
                console.error('Erreur lors de la récupération des données :', error);
            }
        };

        fetchData();

        const interval = setInterval(() => {
            fetchData();
        }, 120000);

        return () => clearInterval(interval);
    }, []);

    if (!data) {
        return <div>Chargement des données...</div>;
    }

    let temperature = parseFloat(data.temperature).toFixed(1);
    let barometre = parseFloat(data.barometer).toFixed(2);
    let radiation = parseFloat(data.solarRad);
    let uv = parseFloat(data.uv)/10;
    let vitesseVent = parseFloat(data.windSpeed).toFixed(1);
    let dirVent = directionVent(data.windDir);
    let humidite = parseFloat(data.humidity).toFixed(1);
    let soilMoisture = parseFloat(data.soilHumidity).toFixed(1);
    let soilTemperature = parseFloat(data.soilTemp).toFixed(1);

    if (data.temperature > 100 || data.temperature < -100) {
        temperature = "...";
    }
    if (data.barometer > 1200 && data.barometer < 900) {
        barometre = "...";
    }
    if (data.solarRad > 2000) {
        radiation = "...";
    }
    if (uv > 12) {
        uv = "...";
    }
    if (data.windSpeed > 200) {
        vitesseVent = "...";
    }
    if (data.windDir >= 360 || data.windDir <= 0) {
        dirVent = "...";
    }
    if (data.humidity > 100 || data.humidity < 0) {
        humidite = "...";
    }



    const date = new Date(data.dateTime)
    //<WeatherInfoCard title="Station météo" value="Relevés Actuels" unit="" className="station-card" />

    return (
        <div className="weather-container">

            <WeatherInfoCard title="Heure du relevé" value={date.toLocaleDateString()+" "+date.toLocaleTimeString()} className="datetime-card" />
            <WeatherInfoCard title="Temperature" value={temperature} unit="°C" className="temperature-card" />
            <WeatherInfoCard title="Humidité" value={humidite} unit="%" className="humidity-card" />
            <WeatherInfoCard title="Rayonnement solaire" value={radiation} unit="W/m²" className="solar-radiation-card" />
            <WeatherInfoCard title="Indice UV" value={uv} unit="UV" className="uv-card" />
            <WeatherInfoCard title="Barometre" value={barometre} unit="hPa" className="barometer-card" />
            <WeatherInfoCard title="Température du sol" value={soilTemperature} unit="°C" className="soil-temperature-card" />
            <WeatherInfoCard title="Humidité du sol" value={soilMoisture} unit="Cb" className="soil-moisture-card" />
            <WeatherInfoCard title="Vitesse du vent" value={vitesseVent} unit="Km/h" className="wind-speed-card" />
            <WeatherInfoCard title="Direction du vent" value={dirVent} unit=" " className="wind-direction-card" />


        </div>
    );
};

export default DonneeInstantanee;
